export const Platform = {
  None: "",
  IOS: "iOS",
  Android: "Android",
  Web: "Web",
} as const;

export type Platform = (typeof Platform)[keyof typeof Platform];
